<template>
  <template v-if="!query || (segments.length === 1 && !segments[0].highlight)">{{ text }}</template>
  <template v-else>
    <template v-for="(segment, i) in segments" :key="i">
      <mark v-if="segment.highlight" class="bg-yellow-200 dark:bg-yellow-700/60 text-inherit rounded-sm px-px">{{ segment.text }}</mark>
      <template v-else>{{ segment.text }}</template>
    </template>
  </template>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  text: string
  query: string
}>()

interface Segment {
  text: string
  highlight: boolean
}

const segments = computed<Segment[]>(() => {
  if (!props.query || !props.text) return [{ text: props.text, highlight: false }]
  
  const result: Segment[] = []
  const lowerText = props.text.toLowerCase()
  const lowerQuery = props.query.toLowerCase()
  let lastIndex = 0
  
  let pos = lowerText.indexOf(lowerQuery, lastIndex)
  
  while (pos !== -1) {
    if (pos > lastIndex) {
      result.push({ text: props.text.slice(lastIndex, pos), highlight: false })
    }
    
    result.push({ text: props.text.slice(pos, pos + lowerQuery.length), highlight: true })
    lastIndex = pos + lowerQuery.length
    pos = lowerText.indexOf(lowerQuery, lastIndex)
  }
  
  if (lastIndex < props.text.length) {
    result.push({ text: props.text.slice(lastIndex), highlight: false })
  }
  
  return result.length > 0 ? result : [{ text: props.text, highlight: false }]
})
</script>